jQuery(document).ready(function(){
  
  function MatchHeight() {
    $(".blog-post-card__info p").matchHeight();
    $(".product-card__info .product-card__title").matchHeight();
    $(".product-card__info .sub-heading").matchHeight();
    $(".scrollable-with-controls .testimonial-list .testimonial").matchHeight();
  }
  setTimeout(function(){
  $('.shopify-payment-button__button').text('Buy it Now');
  },1000);
  MatchHeight();
  jQuery(".facets-drawer__floating-apply button, header button .icon-close").click(function(){
    setTimeout(function(){
      $(".product-card__info .product-card__title").matchHeight();
      $(".product-card__info .sub-heading").matchHeight();
    },1000);
  });
});